// extracted by mini-css-extract-plugin
module.exports = {"categories":"styles-module__categories___2D4bE","category":"styles-module__category___2u1Fh"};